import React from 'react';
import Error from './Error';

export default function PasscodeComplete({ title = "Response Complete.", message = "Your response has already been saved. Thank you.", ...props }) {
    return (<Error title={title} message={message} buttonVisible={true}>{props.children}</Error>);
}